import cn from '../../app/utils/cn';

export type LoaderTone = 'brand' | 'current';

interface ILoaderProps {
  className?: string;
  tone?: LoaderTone;
}

const toneClass: Record<LoaderTone, string> = {
  brand:
    'border-t-green-600 border-r-green-600 border-b-green-600 dark:border-t-green-400 dark:border-r-green-400 dark:border-b-green-400',
  current: 'border-t-current border-r-current border-b-current',
};

export default function Loader({ className, tone = 'brand' }: ILoaderProps) {
  return (
    <div
      data-testid="loader"
      data-tone={tone}
      className={cn(
        'h-10 w-10 animate-spin rounded-full border-2 border-l-transparent',
        toneClass[tone],
        className,
      )}
    ></div>
  );
}
